/**
 * O que as partes da página do Desk Cloud compartilham (a lateral, a lista, os detalhes, a fila): as
 * ações dos menus, abrir um menu, abrir um arquivo, enviar e os diálogos. A casca (DeskCloudState) dá.
 */
import { createContext, useContext } from 'react';
import type { DeskFile, DeskFolder } from '../shared.js';
import type { MenuAnchor, MenuEntry } from '../ui/ContextMenu.js';
import type { CloudActions, FolderActions, MenuContext } from './cloudMenus.js';

export type UploadTarget = { roomId?: string | null; folderId?: string | null };

export type CloudUi = {
  me: string | null;
  mobile: boolean;
  menuContext: MenuContext;
  actions: CloudActions;
  folderActions: FolderActions;
  openMenu: (anchor: MenuAnchor, entries: MenuEntry[], label: string) => void;
  /** o menu certo para o arquivo: o dele, o da seleção (se ele está nela) ou o da lixeira */
  menuForFile: (file: DeskFile, anchor: MenuAnchor) => void;
  menuForFolder: (folder: DeskFolder, anchor: MenuAnchor) => void;
  openFile: (file: DeskFile) => void;
  /** escolher arquivos do computador e mandar para o lugar dado (ou o aberto) */
  upload: (target?: UploadTarget) => void;
  /** onde um envio feito agora entra */
  uploadTarget: () => UploadTarget;
  roomName: (roomId: string) => string;
};

export const CloudUiContext = createContext<CloudUi | null>(null);

export function useCloudUi(): CloudUi {
  const ui = useContext(CloudUiContext);
  if (!ui) throw new Error('useCloudUi fora da página do Desk Cloud');
  return ui;
}

/** O arraste interno: os arquivos (ids) e a pasta que se move para uma pasta, a raiz, uma mesa ou a lixeira. */
export const ITEMS_DRAG = 'application/x-rpgdesk-items';
export const FOLDER_DRAG = 'application/x-rpgdesk-folder';
